const SETTINGS_KEY = "finvault_settings";

export function getSettings() {
  try { return JSON.parse(localStorage.getItem(SETTINGS_KEY)||"{}"); } catch { return {}; }
}

export function saveSettings(s) { localStorage.setItem(SETTINGS_KEY, JSON.stringify(s)); }
export function getCurrencySymbol() { return getSettings().currencySymbol || "₹"; }

export const fmt = n => getCurrencySymbol() + new Intl.NumberFormat("en-IN",{maximumFractionDigits:0}).format(n);
export const fmtFull = n => getCurrencySymbol() + new Intl.NumberFormat("en-IN",{minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(n)||0);
export const toGram4 = n => {
  const num = Number(n || 0);
  if (!Number.isFinite(num)) return 0;
  // Round for display to avoid binary floating point underflow converting
  // exact values such as 39.1339 into 39.1338.
  return Math.round((num + Number.EPSILON) * 10000) / 10000;
};
export const fmtGram = n => `${toGram4(n).toFixed(4)} g`;
export const fmtPrice = n => getCurrencySymbol() + new Intl.NumberFormat("en-IN",{minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(n)||0);
export const fmtDate = d => new Date(d).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"});
export const today = () => new Date().toISOString().split("T")[0];
export const uid2 = () => (crypto?.randomUUID ? crypto.randomUUID().slice(0,8) : Math.random().toString(36).slice(2,10));
